// extracted by mini-css-extract-plugin
export default {"sticky":"fIM2URiqDBoZR084pWU5"};